import React, { useState, useEffect } from "react";
import Modal from "../../../../components/modal"; // Adjust the import path if necessary
import { useSelector } from "react-redux";

const CategoryForm = ({ show, onClose, heading, initialData = {}, onSubmit, units = [], parentCategories = [] }) => {


    const [formData, setFormData] = useState({
        name: '',
        unitId: '',
        parent_id: '',
        isFinalCategory: false,
    });

    // Load initial data into form if editing an existing category
    useEffect(() => {
        if (initialData) {
            setFormData({
                name: initialData.name || '',
                unitId: initialData.unitId || '',
                parent_id: initialData.parent_id || '',
            });
        }
    }, [initialData]);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <Modal
            show={show}
            onClose={onClose}
            heading={heading}
        >
            <form onSubmit={handleSubmit}>
                <div className="row">
                    {/* Name field */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Name</label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter Category Name"
                                required
                            />
                        </div>
                    </div>
                    {/* Unit field */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Unit</label>
                            <select
                                name="unitId"
                                className="form-control"
                                value={formData.unitId}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Unit</option>
                                {units.map((unit) => (
                                    <option key={unit.id} value={unit.id}>
                                        {unit.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {/* Parent Category field */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Parent Category</label>
                            <select
                                name="parent_id"
                                className="form-control"
                                value={formData.parent_id}
                                onChange={handleChange}
                            >
                                <option value="">None (Root Category)</option>
                                {parentCategories.filter(cat => !(initialData && initialData.id) || cat.id !== initialData.id).map((cat) => (
                                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {!initialData?.id && (<div className="col-md-6">
                        <div className="form-check mb-4">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                name="isFinalCategory"
                                checked={formData.isFinalCategory}
                                onChange={(e) => setFormData({ ...formData, isFinalCategory: e.target.checked })}
                            />
                            <label className="form-check-label">Is Final Category</label>
                        </div>
                    </div>)}
                </div>

                <div className="d-flex justify-content-end">
                    <button
                        type="button"
                        className="btn btn-light me-2"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                        Save
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default CategoryForm;
